define('meetings/lib/plugins-modal/plugins',['require','exports','module','knockout','i18next','plugins/dialog','bowser','lodash','api-access','dialog-helper/responsive','mixpanel-helper','coorganizer-search','numeric'],function (require, exports, module) {
    var ko = require('knockout');
    var i18n = require('i18next');
    var dialog = require('plugins/dialog');
    var bowser = require('bowser');
    var _ = require('lodash');
    var user = require('api-access').user;
    var responsiveDialog = require('dialog-helper/responsive');
    var mixpanelHelper = require('mixpanel-helper');

    require('coorganizer-search');
    require('numeric');

    var Plugins = function () {
        var self = this;
        self.bowser = bowser;

        self.isWindows = ko.observable(_.contains(navigator.userAgent.toLowerCase(), 'windows'));
        self.googleCalendarLink = ko.observable();
        self.googleCalendarLink('https://www.gotomeeting.com/features/quick-one-click-meetings');

        self.clickDownload = function (link) {
            if (bowser.safari) {
                window.location.href = link;
            } else {
                window.open(link);
            }
        };

        self.registerModalSeen = function () {
            user.updateSettings({showPlugin: false});
        };

        self.cancel = function () {
            dialog.close(self);
            self.registerModalSeen();
        };

        self.getFooterText = function () {
            return i18n.t('pluginsmodal.footer',
                '<a id="settings-link" href="#settings" data-action="gotoSettings">',
                '</a>');
        };

        self.gotoSettings = function () {
            mixpanelHelper.trackLink('#settings',
                'Navigate to Settings from plugin modal', null);
            dialog.close(self);
            self.registerModalSeen();
        };

        self.gotoLink = function (data, event) {
            var method = $(event.target).data('action');
            if (typeof self[method] == 'function') {
                self[method]();
            }
        };

        self.activate = function () {
            return true;
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
        };
    };

    module.exports = Plugins;
});

